export default function getEnvironment(hostname: string): 'prod' | 'staging' {
	return hostname.endsWith('jira-dev.com') || hostname.endsWith('localhost') ? 'staging' : 'prod';
}
